import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Button, Col, ButtonGroup, ModalHeader, ModalBody, ModalFooter, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Dropdown , Label,} from "reactstrap";
import AboutView from "./CaseSectionsAbout/index";
import ViewSections from "./Sections/index";
import "./CaseSingle.css";
import withAuth from "../../../components/Services/WithAuth";
import * as CaseViewActions from "./action";
import { Preloading } from "../../../components/UI/Preloader/action";
import {
  changeOrder, getSurveyId, xbrlFileStatusCheck, validateAutomationData, validateKycAutomationData, setKycRequestBodyDataAutomation, setRequestBodyDataAutomation,
  updateCrawlerStatusinCaseData, getCrawlerStatusType, getfinalCrawlerStatus, isLegalCrawlerSucceed, isNewsCrawlerSucceed, isCrawlerInInprogressState, dbiAdapter, infocreditAdapter, additionalFieldsExtract,
  isAdditionalLegalCrawlerSucceed, checkForModeration
} from "./Helper";
import { hasCompleted } from "./Sections/Helper";
import Modal from "../../../components/UI/Modal/Modal";
// import SectionRearrange from './SectionRearrange/index'
import PdfView from "../../../components/ReusableComponents/SurveyView/index";
import { toast } from "react-toastify";
import * as constant from "../constants";
import { setPageView } from "../../../components/GoogleAnalytics/index";
import { DataAutomation } from "../CommonComponent/DataAutomationDetails/index";
import { KycDataAutomation } from "../CommonComponent/KycDataAutomationDetails/index";
import ZigramModel from "../CommonComponent/ZigramResponseModel/index";
import ZigramTableView from "../CommonComponent/ZigramResponseModel/ZigramTableView";
import { dataAtuomationInitiate, kycDataAtuomationInitiate, getCrawlerStatus, getKycCrawlerStatus, initiateLegalCrawler, legalSectionTemplateRequest, nicSearchRequest, initiateZigramRequest, initiateZigramExcelRequest, additionalLegalTemplateRequest, additionalLegalUploadRequest, amlPepTemplateRequest, getCrawlerMarkasfail,initiateMasterDataSync, resyncItrAnalysis } from "../CommonComponent/action";
import LegalModeration from "./LegalModeration";
import NewsModeration from "./NewsModeration";
import { requestUnporcessedLegalDataForModeration, responseOfUnprocessedData, requestUnprocessedAdditionalLegalDataForModeration, responseOfUnprocessedAdditionalLegalData } from "./LegalModeration/action";
import { requestUnporcessedNewsDataForModeration, responseOfUnprocessedNewsData } from "./NewsModeration/action";
import { requestMappedCompanyName } from "../RatingCompanyMap/action"
import AllocatePartner from "./AllocatePartner"
import fileSaver from 'file-saver';
import Table from "../../../components/UI/Table/Table";
import Select from 'react-select';
// import CaseViewModal from './CaseViewModal/index'
//import Reorder from '../Create/SectionRearrange/index'
class CaseSectionsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      caseData: [],
      kycCrawlerData: [],
      requestInfoDto: {},
      body: null,
      kycBody: null,
      modal: false,
      kycModal: false,
      onHoldWithdrawModal: false,
      changeCaseToPendingModal: false,
      onHoldWithdrawCaseStatus: "",
      onHoldWithdrawReasonList: [],
      onHoldWithdrawReason: "",
      withdrawReason: "",
      withdrawDisable: false,
      dataAutomationData: {},
      kycAutomationData: {},
      crawlerStatus: "",
      kycCrawlerStatus: "",
      cralwerButtonFlag: false,
      crawlerModal: false,
      kycCrawlerModal: false,
      ratingsModal: false,
      resizeZIndex: false,
      legalModeration: { isLegalCrawlerSucceed: false },
      additionalLegalModeration: { isAdditionalLegalCrawlerSucceed: false },
      newsModeration: { isNewsCrawlerSucceed: false },
      moderateLegal: false,
      moderateAdditionalLegal: false,
      moderateNews: false,
      companyNameOnAgency: {},
      xmlFile: "",
      commonjson: {},
      selectedAgency: "",
      allocatePartner: false,
      additionalFields: {},
      epfNumbers: [],
      latestXbrlXmlFile: null,
      previousXbrlXmlFile: null,
      xbrlModal: null,
      xbrlModalbody: null,
      stockType: null,
      nicOptionsList: [],
      bsaEntityTypes: [],
      bsaBankNames: [],
      bsaAccountTypes: [],
      reportType: null,
      associationEntry: {},
      associationTable: [],
      zigramData: {},
      zigramModel: false,
      zigramExcelData: null,
      associationsType: null,
      cinNumber: null,
      dinNumber: null,
      associationExcelFile: null,
      additionalLegalTemplate: null,
      additionalLegalUploadedFile: null,
      additionalLegalUploadResponse: null,
      enableModeration: false,
      amlPepTemplate: null,
      selectedCountry:"",
      selectedCheckBox:"",
      showKybTable:false,
      isOtpInitiationRequest: false,
      otpInitiateDisabled: false,
      kybModalBody:null,
      submitKybModalTable:false,
      kybSelectedEntity:{},
      kybTableData:[],
      selectedCBindex:'',
    };
    this.refreshInterval = null;
    this.crawlerRefreshInterval = null;
  }
  componentDidMount = () => {
    this.props.getCaseDetails(this.props.match.params.caseNo);
    this.props.preloading(true);
    //this.props.legalSectionTemplateRequest({"sectionDataTableType" :"LIST_OF_VERTICAL_KEY_VALUE"});
    if (this.props.userDetails.scopes === "ROLE_RUBIXANALYST") {
      setPageView("/Analyst/Caseview", document.location.href);
    } else {
      setPageView("/Admin/Caseview", document.location.href);
    }
  };

  componentWillUnmount() {
    this.props.responseOfUnprocessedData({});
    this.props.responseOfUnprocessedNewsData({});
    this.props.responseOfUnprocessedAdditionalLegalData({});
  }

  handleItrResync = () => {
    const row = this.state.selectedRowData || {};
    const corporateId = row.corporateId || this.state.caseData.corporateId;
    if (!row.counterpartyId || !corporateId) {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Counterparty details are missing for ITR resync
        </div>
      );
      return;
    }
    this.props.preloading(true);
    this.toggleModal();
    this.props.resyncItrAnalysis({
      counterpartyId: row.counterpartyId,
      corporateId
    });
  };

  handleOnChange = (e, index) => {

    let legalCases = this.state.legalCases;
    let obj = this.state.legalCases[index];
    let invalidCaseCount = this.state.invalidCaseCount;
    if (e.target.checked) {
      obj = { ...obj, caseInvalid: true };
      invalidCaseCount = invalidCaseCount + 1;
    } else {
      obj = { ...obj, caseInvalid: false }
      invalidCaseCount = invalidCaseCount - 1;
    }
    legalCases[index] = obj;
    this.setState({ legalCases: legalCases, invalidCaseCount: invalidCaseCount })
  }

  handleKybOnChange(event,index,status){
    if (event.target.checked === true){
      let selectedEntityData=this.state.kybTableData[index];
      let filteredEntity = (selectedEntityData.status.toLocaleLowerCase() !== "active") ? {searchId:selectedEntityData.searchId , uid: selectedEntityData.uid, counterpartyId: this.state.caseData.counterpartyId } : selectedEntityData;
        this.setState({
            kybSelectedEntity:filteredEntity,
            selectedCBindex:index
        });
        let arr = document.querySelectorAll('.kybCheckbox');
        let selIndex=index;
          for(let i=0; i<=arr.length-1; i++){
             if(i!==selIndex){
                 arr[i].checked=false;
             }
          }
    } else {
        this.setState({
          kybSelectedEntity:{},
          selectedCBindex:false
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.itrResyncAt && this.props.itrResyncAt !== prevProps.itrResyncAt) {
      this.props.preloading(false);
      if (this.props.itrResyncStatus === "SUCCESS") {
        toast.success(
          <div>
            <i className="fa fa-check-circle"></i>&nbsp;{this.props.itrResyncMessage}
          </div>
        );
        this.handleGetCrawlerStatus();
      } else if (this.props.itrResyncStatus === "FAILURE") {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.itrResyncMessage}
          </div>
        );
      }
    }

    const { automationInitiatedSuccess, automationInitiatedFailure, kycAutomationInitiatedSuccess, kycAutomationInitiatedFailure, xbrlDetails, rerunProcessingSuccess,
      rerunProcessingFailure, uploadXbrl, uploadXbrlFailure, downloadXbrl, downloadXbrlFailure,
      details, 
fetchedBsaEntityTypes, fetchedBsaBankNames, fetchedBsaAccountTypes, sectionListError, reorder, sections, closeCaseData, publishedReport, viewCompletedReportPdf, viewDownloadedReportPdf,
      reopenCaseData, caseDetailsError, withdrawCaseSuccess, withdrawCaseFailure, epfData, legalCrawler, nicSearchResultList, fetchedKYBdata, kybDetailsError, markCasePendingSuccess, markCasePendingFailure,  masterDataSyncStatus,
        masterDataSyncError} = this.props;

    if((fetchedKYBdata !== prevProps.fetchedKYBdata) || ((fetchedKYBdata[0] && fetchedKYBdata[0].searchId && prevProps.fetchedKYBdata[0] && prevProps.fetchedKYBdata[0].searchId) && fetchedKYBdata[0].searchId !==  prevProps.fetchedKYBdata[0].searchId)){
      this.props.preloading(false);
      if(Object.keys(this.state.kybSelectedEntity).length>0){
        let index = this.state.selectedCBindex;
        let selectedEntityData=fetchedKYBdata[index];
        let filteredEntity = (selectedEntityData.status.toLocaleLowerCase() !== "active") ? {searchId:selectedEntityData.searchId , uid: selectedEntityData.uid, counterpartyId: this.state.caseData.counterpartyId } : {...selectedEntityData, counterpartyId: this.state.caseData.counterpartyId };
        this.setState({
            kybSelectedEntity:filteredEntity,
        });
      }
      let pepKybTableColumns = [
        {
            id: 'invalid',
            Cell: (p) => <label>
                <input id={"kybCheckbox"} className={"kybCheckbox"} type="checkbox" style ={{ width: "50px" , height: "20px"}} 
                    onClick={(e) => this.handleKybOnChange(e, p.index, "pepCheck")} />
                </label>
        },
        {
            Header: "Name",
            id: 'name',
            accessor: 'name'
        },
        {
            Header: 'Register Number',
            id: 'registerNumber',
            accessor: 'registerNumber'
        },
        {
            Header: 'UID',
            id: 'uid',
            accessor: 'uid'
        },
        {
            Header: 'Search Id',
            id: 'searchId',
            accessor: 'searchId'
        },
        {
            Header: 'Source',
            id: 'source',
            accessor: 'source'
        },
        {
            Header: 'City',
            id: 'city',
            accessor: 'city'
        },
        {
            Header: 'Address',
            id: 'address',
            accessor: 'address'
        },
        {
            Header: 'Status',
            id: 'status',
            accessor: 'status'
        },
        {
            Header: 'Legal Form',
            id: 'legalForm',
            accessor: 'legalForm'
        },
        {
            Header: 'Issue Date',
            id: 'issueDate',
            accessor: 'issueDate'
        },
        {
            Header: 'Expiry Date',
            id: 'expiryDate',
            accessor: 'expiryDate'
        },
        {
            Header: 'Score',
            id: 'score',
            accessor: 'score'
        },
        {
            Header: 'Trading Name',
            id: 'tradingName',
            accessor: 'tradingName'
        },
        {
            Header: 'Postal Code',
            id: 'postalCode',
            accessor: 'postalCode'
        },
        {
            Header: 'Updated Date',
            id: 'updatedDate',
            accessor: 'updatedDate'
        },
        {
            Header: 'Counterparty Id',
            id: 'counterpartyId',
            accessor: 'counterpartyId'
        }
      ];

      this.setState({
        kycCrawlerModal:false,
        showKybTable:true,
        kybTableData:fetchedKYBdata,
        kybModalBody:(<Table
            data={fetchedKYBdata}
            columns={pepKybTableColumns}
            defaultPageSize={10}
            className="CreateCaseModalTable highlight"
            showPagination={true}
            showPaginationTop={false}
            showPaginationBottom={true}
            noDataText="No Cases found"
        />)
      });
      this.handleKycCrawlerModal();
    }

    if (masterDataSyncStatus !== prevProps.masterDataSyncStatus && masterDataSyncStatus === "SUCCESS") {
    this.props.preloading(false);
    toast.success(
        <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Master Data Sync completed successfully
        </div>
    );
    this.setState({
        dataAutomationData: {},
    });
}

if (masterDataSyncStatus !== prevProps.masterDataSyncStatus && masterDataSyncStatus === "FAILURE") {
    this.props.preloading(false);
    toast.error(
        <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Master Data Sync failed{masterDataSyncError ? `: ${masterDataSyncError}` : ''}
        </div>
    );
 
}
    if(this.props.kybRecordSubmitSuccess !== prevProps.kybRecordSubmitSuccess){
      this.props.preloading(false);
      this.setState({
        showKybTable: false,
      });
      if (this.props.kybRecordSubmitSuccess.status === 200 && this.props.kybRecordSubmitSuccess.data.body.toLowerCase() === 'success') {
        toast.success(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {"KYB data has been submitted successfully"}
          </div>);
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {`Error in submitting KYB data: ${this.props.kybRecordSubmitSuccess.data && this.props.kybRecordSubmitSuccess.data.body && this.props.kybRecordSubmitSuccess.data.body}`}
          </div>
        );
      }
    }

    if(this.props.kybRecordSubmitError !== prevProps.kybRecordSubmitError){
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp; {`Error in submitting KYB data: ${String(this.props.kybRecordSubmitError)}`}
        </div>
      );
    }

    if (this.props.epfData !== prevProps.epfData) {
      this.setState({
        epfNumbers: this.props.epfData.data
      });
    }
    if (this.props.zigramData !== prevProps.zigramData) {
      this.props.preloading(false);
      if (this.props.zigramData.status === "SUCCESS") {
        this.setState({
          zigramData: this.props.zigramData.data,
          zigramModel: true
        });
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.zigramData.data.data}
          </div>
        );
      }

    }
    if (this.props.zigramExcelData !== prevProps.zigramExcelData) {
      this.props.preloading(false);
      this.setState({
        zigramModel: false
      });
      if (this.props.zigramExcelData.status === "SUCCESS") {
        toast.success(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.zigramExcelData.data}
          </div>);
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.zigramExcelData.data}
          </div>
        );
      }
    }

    if (this.props.nicSearchResultList !== prevProps.nicSearchResultList) {
      // set label & value from nic search response
      let nicOptionsList = []
      if (this.props.nicSearchResultList.length > 0) {
        for (var key in this.props.nicSearchResultList) {
          var tempObj = {}
          tempObj['label'] = this.props.nicSearchResultList[key].nicCode + " - " + this.props.nicSearchResultList[key].description
          tempObj['value'] = this.props.nicSearchResultList[key].nicCode
          tempObj['description'] = this.props.nicSearchResultList[key].description
          nicOptionsList.push(tempObj)
        }
      }

      this.setState({
        nicOptionsList: nicOptionsList
      })
    }

    if (this.props.legalCrawler !== prevProps.legalCrawler) {
      this.props.preloading(false);
      if (this.props.legalCrawler.status === "SUCCESS") {
        toast.success(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Crawler Initiated
            Successfully
          </div>,
        );
        this.props.getCrawlerStatus([{ counterpartyId: this.state.caseData.counterpartyId, corporateId: this.state.caseData.corporateId }]);
        this.setState({
          dataAutomationData: {},
        });
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; Please Try Again!
          </div>
        );
      }
    }

    if (this.props.additionalLegalTemplate !== prevProps.additionalLegalTemplate) {
      this.props.preloading(false);
      if (this.props.additionalLegalTemplate.status === "SUCCESS") {
        const data = this.props.additionalLegalTemplate.data;
        let blob = new Blob([data], { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, `${"Additional_Legal_Upload_Template"}_${this.state.caseData.counterpartyName}.xlsx`);
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.legalCrawler.data.data.message}
          </div>
        );
      }
    }

    if (this.props.amlPepTemplate !== prevProps.amlPepTemplate) {
      this.props.preloading(false);
      if (this.props.amlPepTemplate.status === "SUCCESS") {
        const data = this.props.amlPepTemplate.data;
        let blob = new Blob([data], { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, `${"Association_Excel"}.xlsx`);
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.legalCrawler.data.data.message}
          </div>
        );
      }
    }

    if (this.props.additionalLegalUploadResponse != prevProps.additionalLegalUploadResponse) {
      this.props.preloading(false);
      if (this.props.additionalLegalUploadResponse.status === "SUCCESS") {
        toast.success(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Additional Legal Crawler Initiated
            Successfully
          </div>,
        );
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;
            {this.props.additionalLegalUploadResponse.data}
          </div>,
        );
      }
    }

    if (automationInitiatedSuccess !== prevProps.automationInitiatedSuccess) {
      this.props.preloading(false);
      
      // Check if this was an OTP initiation request for Retail Bureau
      if (this.state.isOtpInitiationRequest) {
        toast.success(
          <div>
            <i className="fa fa-check-circle"></i>&nbsp;Request initiated Successfully, Please enter the OTP if received and click Run.
          </div>,
        );
        // Re-enable the Initiate button after 30 seconds to prevent spamming
        setTimeout(() => {
          this.setState({ otpInitiateDisabled: false });
        }, 30000);
        this.setState({ isOtpInitiationRequest: false });
      } else {
        // Normal automation success - close modal and reset state
        toast.success(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Crawler Initiated
            Successfully
          </div>,
        );
        this.props.getCrawlerStatus([{ counterpartyId: this.state.caseData.counterpartyId, corporateId: this.state.caseData.corporateId }]);
        this.setState({
          dataAutomationData: {},
        });
      }
    }
    if (kycAutomationInitiatedSuccess !== prevProps.kycAutomationInitiatedSuccess) {
      this.props.preloading(false);
      toast.success(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Kyc Crawler Initiated
          Successfully
        </div>,
      );
      this.props.getKycCrawlerStatus({ counterpartyId: this.state.caseData.counterpartyId, corporateId: this.state.caseData.corporateId });
      this.setState({
        kycAutomationData: {},
      });
    }

    if (this.props.KycCrawlerStatusSuccess !== prevProps.KycCrawlerStatusSuccess) {
      this.setState({
        cralwerButtonFlag: true
      })

      if (this.props.KycCrawlerStatusSuccess.length > 0) {
        this.setState({
          kycCrawlerStatus: getfinalCrawlerStatus(this.props.KycCrawlerStatusSuccess),
        });

      } else {
        this.setState({
          kycCrawlerStatus: "",
        });
      }
    }

    if (this.props.crawlerStatusSuccess !== prevProps.crawlerStatusSuccess) {
      this.setState({
        cralwerButtonFlag: true
      })
      if (this.state.activeTab === constant.PENDING) {
        let tempCaseData = updateCrawlerStatusinCaseData(
          this.props.details.data,
          this.props.crawlerStatusSuccess,
        );
        this.setState({
          caseData: tempCaseData,
        });
      }
      if (this.props.crawlerStatusSuccess.length > 0) {
        this.setState({
          crawlerStatus: getfinalCrawlerStatus(this.props.crawlerStatusSuccess),
        });

      } else {
        this.setState({
          crawlerStatus: "",
        });
      }

      this.setState({
        additionalLegalModeration: isAdditionalLegalCrawlerSucceed(this.props.crawlerStatusSuccess, this.state.caseData.corporateId)
      }, () => {
        if (this.state.additionalLegalModeration.isAdditionalLegalCrawlerSucceed && (!this.props.additionalLegalUnprocessedData || !this.props.additionalLegalUnprocessedData.results)) {
          this.props.requestUnprocessedAdditionalLegalDataForModeration(this.state.additionalLegalModeration.counterpartyId);
        }
      })

      this.setState({
        legalModeration: isLegalCrawlerSucceed(this.props.crawlerStatusSuccess, this.state.caseData.corporateId)
      }, () => {
        if (this.state.legalModeration.isLegalCrawlerSucceed && (!this.props.legalUnprocessedData || !this.props.legalUnprocessedData.results)) {
          this.props.requestUnporcessedLegalDataForModeration(this.state.legalModeration.counterpartyId);
        }
      })

      this.setState({
        newsModeration: isNewsCrawlerSucceed(this.props.crawlerStatusSuccess, this.state.caseData.corporateId)
      }, () => {
        if (this.state.newsModeration.isNewsCrawlerSucceed && (!this.props.newsUnprocessedData || !this.props.newsUnprocessedData.results)) {
          this.props.requestUnporcessedNewsDataForModeration(this.state.newsModeration.counterpartyId);
        }
      })

      this.setState({
        enableModeration: checkForModeration(this.props.crawlerStatusSuccess, this.state.caseData.corporateId)
      })
    }//crawler status 
    if (automationInitiatedFailure !== prevProps.automationInitiatedFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;
          {this.props.automationInitiatedFailure.data.message}
        </div>,
      );
      
      // Re-enable the OTP initiate button if the failure was during OTP initiation
      if (this.state.isOtpInitiationRequest) {
        this.setState({ 
          isOtpInitiationRequest: false,
          otpInitiateDisabled: false 
        });
      }
    }
    if (kycAutomationInitiatedFailure !== prevProps.kycAutomationInitiatedFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;
          {this.props.kycAutomationInitiatedFailure.data.message}
        </div>,
      );
    }

    if (xbrlDetails !== prevProps.xbrlDetails) {
      const statusFlag = xbrlFileStatusCheck(xbrlDetails.status);
      if (!statusFlag) {
        this.refreshInterval = setTimeout(() => {
          this.props.fetchXbrlDetails(details.data.counterpartyId);
        }, 10000);
      } else {
        if (this.refreshInterval) {
          clearTimeout(this.refreshInterval);
        }
      }
    }
    if (rerunProcessingSuccess !== prevProps.rerunProcessingSuccess) {
      this.props.preloading(false);
      toast.success(<div>{rerunProcessingSuccess}</div>);
      this.props.fetchXbrlDetails(details.data.counterpartyId);
    }
    if (rerunProcessingFailure !== prevProps.rerunProcessingFailure) {
      this.props.preloading(false);
      toast.error(<div>{rerunProcessingFailure.data.message}</div>);
    }
    if (uploadXbrl !== prevProps.uploadXbrl) {
      this.props.preloading(false);
      toast.success(<div>XBRL uploaded successfully</div>);
      this.props.fetchXbrlDetails(details.data.counterpartyId);
    }
    if (uploadXbrlFailure !== prevProps.uploadXbrlFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;
          {uploadXbrlFailure.data.message}
        </div>,
      );
    }
    if (downloadXbrl !== prevProps.downloadXbrl) {
      this.props.preloading(false);
      window.open(downloadXbrl);
    }
    if (downloadXbrlFailure !== prevProps.downloadXbrlFailure) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;
          {downloadXbrlFailure.data.message}
        </div>,
      );
    }
    if (details !== prevProps.details) {
      let additionalFields = additionalFieldsExtract(this.props.details.data);
      this.setState({ caseData: this.props.details.data, additionalFields: additionalFields, onHoldWithdrawReason: "" });
      const sectionRequestBody = getSurveyId(this.props.details.data);
      this.props.fetchXbrlDetails(details.data.counterpartyId);
      this.props.getAllSections(this.props.details.data.computedReportId);
      this.props.getBsaEntityTypes();
      this.props.getBsaBankNames();
      this.props.getBsaAccountTypes();
      this.props.getCrawlerStatus([{ counterpartyId: this.props.details.data.counterpartyId, corporateId: this.props.details.data.corporateId }]);
      this.props.getKycCrawlerStatus({ counterpartyId: this.props.details.data.counterpartyId, corporateId: this.props.details.data.corporateId });
    }
    if (caseDetailsError !== prevProps.caseDetailsError) {
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Failed to Fetch
          Case Details
        </div>,
      );
    }
    if (fetchedBsaEntityTypes !== prevProps.fetchedBsaEntityTypes) {
      let structuredBsaEntityTypes = fetchedBsaEntityTypes.data ? fetchedBsaEntityTypes.data.map((elem) => { return { value: elem, label: elem }; }) : []
      this.setState({ bsaEntityTypes: structuredBsaEntityTypes })
    }
    if (fetchedBsaBankNames !== prevProps.fetchedBsaBankNames) {
      let structuredBsaBankNames = fetchedBsaBankNames.data ? fetchedBsaBankNames.data.map((elem) => { return { value: elem, label: elem }; }) : []
      this.setState({ bsaBankNames: structuredBsaBankNames })
    }
    if (fetchedBsaAccountTypes !== prevProps.fetchedBsaAccountTypes) {
      let structuredBsaAccountTypes = fetchedBsaAccountTypes.data ? fetchedBsaAccountTypes.data.map((elem) => { return { value: elem, label: elem }; }) : []
      this.setState({ bsaAccountTypes: structuredBsaAccountTypes })
    }
    if (sectionListError !== prevProps.sectionListError) {
      this.handleToggle();
      if (reorder) {
        this.setState({
          body: (
            <div>
              <h5 className="text-danger">
                <i className="fa fa-exclamation-triangle"></i>&nbsp;Error
              </h5>
              <h5>Reordering Unsuccessful</h5>
              <h5>{(sectionListError.response && sectionListError.response.data) ? sectionListError.response.data.message : "Something went wrong! Please try again."}</h5>
              <button className="btn btn-danger" onClick={this.handleToggle}>
                OK
              </button>
            </div>
          ),
        });
      } else {
        this.setState({
          body: (
            <div>
              <h5 className="text-danger">
                <i className="fa fa-exclamation-triangle"></i>&nbsp;Error
              </h5>
              <h5>Error loading sections.</h5>
              <h5>{(sectionListError.response && sectionListError.response.data) ? sectionListError.response.data.message : "Something went wrong! Please try again."}</h5>
              <button className="btn btn-danger" onClick={this.handleToggle}>
                OK
              </button>
            </div>
          ),
        });
      }
      this.props.preloading(false);
    } else if (
      !sectionListError.error &&
      reorder === true &&
      sections !== prevProps.sections
    ) {
      this.setState({
        body: (
          <div>
            <h5 className="text-success">
              <i className="fa fa-check-circle"></i>Success
            </h5>
            <h5>Reordering Successful</h5>
            <button
              className="btn btn-danger"
              onClick={this.handleReorderSuccess}
            >
              OK
            </button>
          </div>
        ),
      }, () => {
        this.handleToggle();
      });
      this.props.preloading(false);
    }
    if (closeCaseData.error && closeCaseData !== prevProps.closeCaseData) {
      this.handleToggle();
      this.setState({
        body: (
          <div>
            <h5 className="text-danger">
              <i className="fa fa-exclamation-triangle"></i>&nbsp;Error
            </h5>
            <h5>Case couldn&#39;t be closed.</h5>
            <h5>{(closeCaseData.error.response && closeCaseData.error.response.data) ? closeCaseData.error.response.data.message : "Something went wrong! Please try again."}</h5>
            <button className="btn btn-danger" onClick={this.handleToggle}>
              OK
            </button>
          </div>
        ),
      });
      this.props.preloading(false);
    } else if (
      !closeCaseData.error &&
      closeCaseData !== prevProps.closeCaseData
    ) {
      this.props.preloading(false);
      toast.success(
        <div>
          <i className="fa fa-check"></i>&nbsp;Case successfully closed
        </div>,
      );
    }

    if (
      publishedReport.error &&
      publishedReport !== prevProps.publishedReport
    ) {
      this.handleToggle();
      this.setState({
        body: (
          <div>
            <h5 className="text-danger">Error</h5>
            <h5>{(publishedReport.error.response && publishedReport.error.response.data) ? publishedReport.error.response.data.message : "Something went wrong! Please try again."}</h5>
            <button className="btn btn-danger" onClick={this.handleToggle}>
              OK
            </button>
          </div>
        ),
      });
      this.props.preloading(false);
    } else if (
      !publishedReport.error &&
      publishedReport !== prevProps.publishedReport
    ) {
      this.handleToggle();
      this.setState({
        body: (
          <div>
            <h5 className="text-success">Success</h5>
            <h5>Publish Successful</h5>
            <button className="btn btn-success" onClick={this.handleToggle}>
              OK
            </button>
          </div>
        ),
      });
      this.props.preloading(false);
    }

    if (
      viewCompletedReportPdf.error &&
      viewCompletedReportPdf !== prevProps.viewCompletedReportPdf
    ) {
      this.setState({
        body: (
          <div>
            <h5 className="text-danger">Error</h5>
            <h5>{(viewCompletedReportPdf.error.response && viewCompletedReportPdf.error.response.data) ? viewCompletedReportPdf.error.response.data.message : "Something went wrong! Please try again."}</h5>
            <button className="btn btn-danger" onClick={this.handleToggle}>
              OK
            </button>
          </div>
        ),
      });
      this.props.preloading(false);
    } else if (
      !viewCompletedReportPdf.error &&
      viewCompletedReportPdf !== prevProps.viewCompletedReportPdf
    ) {
      const temp = {
        pdfUrl: viewCompletedReportPdf.data,
        height: "390px",
      };
      this.setState({
        body: (
          <div>
            <PdfView {...temp} />
            <button
              className="btn btn-success mt-5"
              onClick={this.handleToggle}
            >
              OK
            </button>
          </div>
        ),
      });
      this.props.preloading(false);
    }

    if (reopenCaseData.error && reopenCaseData !== prevProps.reopenCaseData) {
      this.handleToggle();
      this.setState({
        body: (
          <div>
            <h5 className="text-danger">Error</h5>
            <h5>{(reopenCaseData.error.response && reopenCaseData.error.response.data) ? reopenCaseData.error.response.data.message : "Something went wrong! Please try again."}</h5>
            <button className="btn btn-danger" onClick={this.handleToggle}>
              OK
            </button>
          </div>
        ),
      });
      this.props.preloading(false);
    } else if (
      !reopenCaseData.error &&
      reopenCaseData !== prevProps.reopenCaseData
    ) {
      this.props.preloading(false);
      toast.success(
        <div>
          <i className="fa fa-check"></i>&nbsp;Case successfully reopened
        </div>,
      );
    }
    if (withdrawCaseSuccess !== prevProps.withdrawCaseSuccess) {
      this.props.getCaseDetails(this.props.match.params.caseNo);
      this.handleToggle();
      toast.success(
        <div>
          <i className="fa fa-check"></i>&nbsp;{withdrawCaseSuccess.data.message}
        </div>,
      );
    } else if (withdrawCaseFailure !== prevProps.withdrawCaseFailure) {
      this.handleToggle();
      this.props.preloading(false);
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;
          {(withdrawCaseFailure.response && withdrawCaseFailure.response.data) ? withdrawCaseFailure.response.data.message : "Something went wrong! Please try again."}
        </div>,
      );
    }

    if (markCasePendingSuccess != prevProps.markCasePendingSuccess) {
      this.props.getCaseDetails(this.props.match.params.caseNo);
      toast.success(
        <div>
          <i className="fa fa-check"></i>&nbsp;{markCasePendingSuccess.data.message}
        </div>,
      );
      this.props.preloading(false);
    }

    if (markCasePendingFailure != prevProps.markCasePendingFailure) {
      toast.error(
        <div>
          <i className="fa fa-check"></i>&nbsp;{markCasePendingFailure.data.message}
        </div>,
      );
      this.props.preloading(false);
    }

  }

  handleReorderSuccess = () => {
    this.handleToggle();
    this.props.changeReorderStatus();
  };

  handlePublishReport = () => {
    this.handleToggle();
    this.setState(
      {
        body: (
          <div>
            <h5>Are you sure you want to Publish ?</h5>
            <button
              className="btn btn-primary mt-5"
              onClick={this.handlePublish}
            >
              OK
            </button>
            <button
              className="btn btn-danger mt-5 ml-3"
              onClick={this.handleToggle}
            >
              Cancel
            </button>
          </div>
        ),
      },
      () => {
        this.handleToggle();
      },
    );
  };

  handleCloseCase = () => {
    this.setState(
      {
        body: (
          <div>
            <h5>Are you sure you want to Close ?</h5>
            <button className="btn btn-primary mt-5" onClick={this.onCloseCase}>
              OK
            </button>
            <button
              className="btn btn-danger mt-5 ml-3"
              onClick={this.handleToggle}
            >
              Cancel
            </button>
          </div>
        ),
      },
      () => {
        this.handleToggle();
      },
    );
  };

  onCloseCase = () => {
    this.props.preloading(true);
    this.props.closeCase(this.props.details.data.caseId);
    this.handleToggle();
  };

  handleBack = e => {
    this.props.history.push("/case");
  };

  handleCloseRearrange = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
      body: null
    }));
  };

  handleReorder = param => {
    this.props.preloading(true);
    let newOrder = changeOrder(param);
    this.props.reorderSections(
      this.props.details.data.computedReportId,
      newOrder,
    );
    this.handleToggle();
  };

  handleCrawlerModal = () => {
    let flag = this.state.crawlerModal;
    this.setState({
      crawlerModal: !this.state.crawlerModal
    }, () => {
      if (flag) {
        this.handleToggle();
      }
    })

  }

  handleGetCrawlerStatus = () => {
    this.props.getCrawlerStatus([{ counterpartyId: this.state.caseData.counterpartyId, corporateId: this.state.caseData.corporateId }])
  }
  markCrawlerAsfail = () => {
    let requestBody = { corporateId: this.state.caseData.corporateId, counterpartyId: this.state.caseData.counterpartyId, crawlerName: "", crawlerStatus: "FAILURE" }
    requestBody.crawlerName = Object.keys(this.state.dataAutomationData).find(key => this.state.dataAutomationData[key] === true);
    this.props.getCrawlerMarkasfail(requestBody);
  }
  handleGetKycCrawlerStatus = () => {
    this.props.getKycCrawlerStatus({ counterpartyId: this.state.caseData.counterpartyId, corporateId: this.state.caseData.corporateId })
  }

  openRatingsCompanySearchTab = () => {
    window.open('/case/companysearch/' + this.props.match.params.caseNo, "_blank");
  }

  uploadXML = (event) => {
    if (this.state.selectedAgency !== "") {
      let fileName = event.target.files[0].name;
      let fileExtention = fileName.substr(fileName.length - 4);
      if (fileExtention === ".xml") {
        let res;
        const reader = new FileReader()
        reader.readAsText(event.target.files[0])
        reader.onloadend = (evt, event) => {
          const readerData = evt.target.result;
          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(readerData, "text/xml");

          let selectedAgency = this.state.selectedAgency;
          if (selectedAgency === "Dynamic Business Information") {
            if (xmlDoc.getElementsByTagName("Report").length !== 0) {
              let json = dbiAdapter(this.props.details.data.caseId, this.state.caseData.counterpartyId, xmlDoc);
              this.setState({ commonjson: json });
            }
            else {
              toast.error(
                <div>
                  <i className="fa fa-exclamation-triangle"></i>&nbsp; Invalid XML format.
                </div>
              )
              this.resetXMLUpload();
            }
          }
          else if (selectedAgency === "Infocredit Group") {
            if (xmlDoc.getElementsByTagName("company").length !== 0) {
              let infoJson = infocreditAdapter(this.props.details.data.caseId, this.state.caseData.counterpartyId, xmlDoc);
              this.setState({ commonjson: infoJson });
            }
            else {
              toast.error(
                <div>
                  <i className="fa fa-exclamation-triangle"></i>&nbsp; Invalid XML format.
                </div>
              )
              this.resetXMLUpload();
            }
          }
        };

        this.setState({
          xmlFile: event.target.files[0]
        })
        this.handleDataAutomationRequiredData(event);
        event.preventDefault();
        event.target.value = null;
      }
      else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload xml file.
          </div>
        )
      }
    } else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please Select Agency name.
        </div>
      )
    }
  }

  uploadLatestXbrlXml = (event) => {
    if (this.state.caseData.cinNumber !== null) {
      let fileName = event.target.files[0].name;
      let fileExtention = fileName.substr(fileName.length - 4);
      if (fileExtention === ".xml") {
        this.setState({ latestXbrlXmlFile: event.target.files[0] })
        const reader = new FileReader()
        reader.readAsText(event.target.files[0])
        reader.onloadend = (evt, event) => {
          const readerData = evt.target.result;
          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(readerData, "text/xml");
          this.setState({ xmlCinNumber: xmlDoc.getElementsByTagName('xbrli:identifier')[0].innerHTML })
          if (this.state.caseData.cinNumber !== xmlDoc.getElementsByTagName('xbrli:identifier')[0].innerHTML) {
            this.setState(prevState => ({
              modal: !prevState.modal,
              xbrlModal: !prevState.xbrlModal,
              xbrlModalbody: <div>
                <ModalHeader>Confirm</ModalHeader>
                <ModalBody>
                  <span className="text-danger">XML Cin Number ({xmlDoc.getElementsByTagName('xbrli:identifier')[0].innerHTML}) not matching with case Cin Number, Are you sure to continue? </span>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={this.cancelLatestModal}>Cancel</Button>
                  <Button color="primary" onClick={this.handleLatestModal}>Ok</Button>
                </ModalFooter>
              </div>
            }))
          }
        };
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload xml file.
          </div>
        )
      }
    } else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;CIN Number not available for this case.
        </div>
      )
    }
  }

  cancelLatestModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal, xbrlModal: !prevState.xbrlModal, latestXbrlXmlFile: "", xbrlModalbody: null }))
  }

  handleLatestModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal, xbrlModal: !prevState.xbrlModal, xbrlModalbody: null }))
  }

  uploadPreviousXbrlXml = (event) => {
    if (this.state.latestXbrlXmlFile === null) {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Latest xml file first.
        </div>
      )
    } else {
      if (this.state.caseData.cinNumber !== null) {
        let fileName = event.target.files[0].name;
        let fileExtention = fileName.substr(fileName.length - 4);
        if (fileExtention === ".xml") {
          this.setState({ previousXbrlXmlFile: event.target.files[0] })
          const reader = new FileReader()
          reader.readAsText(event.target.files[0])
          reader.onloadend = (evt, event) => {
            const readerData = evt.target.result;
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(readerData, "text/xml");
            if (this.state.caseData.cinNumber !== xmlDoc.getElementsByTagName('xbrli:identifier')[0].innerHTML) {
              this.setState(prevState => ({
                modal: !prevState.modal,
                xbrlModal: !prevState.xbrlModal,
                xbrlModalbody: <div>
                  <ModalHeader>Confirm</ModalHeader>
                  <ModalBody>
                    <span className="text-danger">XML Cin Number ({xmlDoc.getElementsByTagName('xbrli:identifier')[0].innerHTML}) not matching with case Cin Number, Are you sure to continue? </span>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={this.cancelPreviousModal}>Cancel</Button>
                    <Button color="primary" onClick={this.handlePreviousModal}>Ok</Button>
                  </ModalFooter>
                </div>
              }))
            }
          };
        } else {
          toast.error(
            <div>
              <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload xml file.
            </div>
          )
        }
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;CIN Number not available for this case.
          </div>
        )
      }
    }
  }

  cancelPreviousModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal, xbrlModal: !prevState.xbrlModal, previousXbrlXmlFile: "", xbrlModalbody: null }))
  }

  handlePreviousModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal, xbrlModal: !prevState.xbrlModal, xbrlModalbody: null }))
  }

  resetXMLUpload = () => {
    let tempAutomationData = {};
    tempAutomationData = {
      ...this.state.caseData,
      INTERNATIONAL: ""
    };
    this.setState({
      xmlFile: "", caseData: tempAutomationData
    })
  }

  handleAgencyDropdown = (event) => {
    this.setState({ selectedAgency: event.target.value });
  }

  handleToggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
    if (this.state.crawlerModal) {
      this.handleCrawlerModal();
    }
  };

  viewPublishedReport = () => {
    this.props.preloading(true);
    this.props.viewPublishedReport(this.props.details.data.computedReportId);
    this.handleToggle();
  };
  viewDownloadedReport = () => {
    this.props.preloading(true);
    this.props.viewDownloadedReport(this.props.details.data.computedReportId, this.props.details.data.counterpartyName
      + "_" + this.props.details.data.corporateName);
    this.props.preloading(false);
    this.handleToggle();
  };
  handlePreview = () => {
    this.props.preloading(true);
    this.props.previewReport({
      id: this.props.details.data.computedReportId,
      requestType: this.props.details.data.requestType,
      caseType: this.props.details.data.caseType
    });
  };

  handleReopenCase = () => {
    this.handleToggle();
    this.setState({
      body: (
        <div>
          <h5>Are you sure you want to Reopen the case ?</h5>
          <button className="btn btn-primary mt-5" onClick={this.onReopenCase}>
            OK
          </button>
          <button
            className="btn btn-danger mt-5 ml-3"
            onClick={this.handleToggle}
          >
            Cancel
          </button>
        </div>
      ),
    });
  };
  onReopenCase = () => {
    this.props.preloading(true);
    this.props.reopenCase(
      this.props.details.data.caseId,
      this.props.details.data.id,
    );
    this.handleToggle();
  };
  handleTextArea = event => {
    this.setState({
      withdrawReason: event.target.value,
    });
  };

  handleKycCrawlerModal = () => {
    let flag = this.state.kycCrawlerModal;
    this.setState({
      kycCrawlerModal: !this.state.kycCrawlerModal
    }, () => {
      if (flag) {
        this.handleKycToggle();
      }
    })

  }

  handleKycToggle = () => {
    this.setState(prevState => ({
      kycModal: !prevState.kycModal,
    }));
    if (this.state.kycCrawlerModal) {
      this.handleKycCrawlerModal();
    }
  };

  toggleKycModal = () => {
    this.setState(prevState => ({
      kycModal: !prevState.kycModal,
    }));
  };
  setKycCrawlerData = (caseData) => {

    let tempData = {
      ...this.state.kycCrawlerData,
      counterpartyName: caseData.counterpartyName,
      counterpartyAddress: caseData.counterpartyAddress,
      gstNo: caseData.gstNo,
      panNo: caseData.panNo,
    };
    this.setState({
      kycCrawlerData: tempData
    });
  }

  handleKycCrawlerInitiate = (flag) => {
    if (flag) {
      this.setKycCrawlerData(this.state.caseData);
      this.props.requestMappedCompanyName(this.state.caseData.counterpartyId);
      this.toggleKycModal()
    }
    this.setState({
      kycBody: null
    }, () => {
      if (!this.state.kycCrawlerModal) {
        this.handleKycCrawlerModal()
      }
    });

  };

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  handleCrawlerInitiate = (selectedRowData, flag) => {

    if (flag) {
      this.props.requestMappedCompanyName(this.state.caseData.counterpartyId);
      this.toggleModal();
    }
    this.setState({
      selectedRowData: selectedRowData,
      body: null
    }, () => {
      if (!this.state.crawlerModal) {
        this.handleCrawlerModal()
      }
    });
  };

  handleLegalData = (e) => {
    if (e.target.checked) {
    } else {
    }

    let tempAutomationData = {
      ...this.state.caseData,
      'LEGAL': true,
      [e.target.name]: e.target.value
    };

    this.setState({

      caseData: tempAutomationData,
    });

  }

  handleLegalDropdownData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      'LEGAL': true,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData,
    });
  }

  downloadAdditionalLegalTemplate = () => {
    this.props.preloading(true);
    this.props.additionalLegalTemplateRequest();
  }

  downloadAMLPEPTemplate = () => {
    this.props.preloading(true);
    this.props.amlPepTemplateRequest();
  }

  uploadAdditionalLegalFile = (e) => {
    let file = e.target.files[0];
    if (file && file.name && file.name.endsWith(".xlsx")) {
      let additionalLegalObject = {
        counterpartyName: this.state.caseData.counterpartyName,
        corporateId: this.state.caseData.corporateId,
        counterpartyId: this.state.caseData.counterpartyId,
        panNo: this.state.caseData.panNo,
        caseId: this.state.caseData.caseId,
      }
      let requestBody = new FormData();
      requestBody.append('crawlerModel', JSON.stringify(additionalLegalObject));
      requestBody.append('additionalLegalFile', file);
      this.props.preloading(true);
      this.toggleModal();
      this.props.additionalLegalUploadRequest(requestBody);
    } else {
      this.setState({
        ...this.state.caseData,
        additionalLegalUploadedFile: undefined,
      });
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Excel file.
        </div>
      )
    }
  }

  handleNewsData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData,
    });
  }

  handleSocialMediaData = (e) => {
    let tempAutomationData = {};
    if (e.target.name == "socialMediaName") {
      tempAutomationData = {
        ...this.state.caseData,
        [e.target.name]: e.target.value
      };
    }

    if (e.target.name == "socialMediaAddress") {
      tempAutomationData = {
        ...this.state.caseData,
        [e.target.name]: e.target.value
      };
    }

    this.setState({
      caseData: tempAutomationData,
    });
  }

  handleRatingsData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }
  handleBseNseData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };
    this.setState({
      caseData: tempAutomationData
    })
  }

  handleLeiData = (e) => {
    if (e.target.checked) {
    } else {
    }
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleRetailBureauData = (e) => {
    if (e.target.checked) {
    } else {
    }
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleIECData = (e) => {
    let tempAutomationData = {};
    if (e.target.checked) {
    } else {
    }

    if (e.target.name == "iecIdentifier") {
      tempAutomationData = {
        ...this.state.caseData,
        [e.target.name]: e.target.value
      };
    }
    if (e.target.name == "iecCompanyName") {
      tempAutomationData = {
        ...this.state.caseData,
        [e.target.name]: e.target.value
      };
    }

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleUdyamData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleUdyogData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleItrAnalysisRequest = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  getNICOptionsList = (searchResult) => {
    return searchResult;
  };

  loadNICOptions = (inputValue, callback) => {
    if (inputValue && inputValue != "" && inputValue.length > 1) {
      this.props.nicSearchRequest(inputValue);
      setTimeout(() => {
        callback(this.getNICOptionsList(this.state.nicOptionsList));
      }, 2000);
    }
  };

  handleNicData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      'nicCode': e.value,
      'nicCodeDescription': e.description
    };

    this.setState({
      nicSelectedValue: e.value,
      caseData: tempAutomationData
    })
  }
  handleKycCheckboxchange = event => {
    let tempData = event.target.name;
    let tempkycCrawlerData={...this.state.kycCrawlerData,selectCounterpartyName:this.state.kycCrawlerData.counterpartyName}
    this.setState({selectedCheckBox:tempData, kycCrawlerData:tempkycCrawlerData})
    let dataAutomation = Object.assign({}, this.state.kycAutomationData);
    dataAutomation = {
      ...dataAutomation,
      [tempData]: event.target.checked,
    };
    this.setState(
      {
        kycAutomationData: dataAutomation
      },
      () => {
        this.handleKycCrawlerInitiate(false);
      },
    );
  }


  handleKycCrawlerData = (e) => {
    if (e.target.checked) {
    } else {
    }
    let tempAutomationData = {
      ...this.state.kycCrawlerData,
      [e.target.name]: e.target.value
    };

    this.setState({
      kycCrawlerData: tempAutomationData
    })
  }

  handleCheckboxchange = event => {
    let tempData = event.target.name;
    let dataAutomation = Object.assign({}, this.state.dataAutomationData);
    dataAutomation = {
      ...dataAutomation,
      [tempData]: event.target.checked,
    };

    if (tempData == "SOCIALMEDIA") {
      this.setState(
        {
          dataAutomationData: dataAutomation,
          caseData: {
            ...this.state.caseData, 'LEGAL_name': this.state.caseData.counterpartyName,
            'socialMediaName': this.state.caseData.counterpartyName,
            'socialMediaAddress': this.state.caseData.counterpartyAddress
          }
        },
        () => {
          this.handleCrawlerInitiate(this.props.details.data, false);
        },
      );
    } else if (tempData == "IEC") {
      this.setState(
        {
          dataAutomationData: dataAutomation,
          caseData: {
            ...this.state.caseData, 'LEGAL_name': this.state.caseData.counterpartyName,
            'iecCompanyName': this.state.caseData.counterpartyName
          }
        },
        () => {
          this.handleCrawlerInitiate(this.props.details.data, false);
        },
      );
    } else {
      this.setState(
        {
          dataAutomationData: dataAutomation,
          caseData: { ...this.state.caseData, 'LEGAL_name': this.state.caseData.counterpartyName }
        },
        () => {
          this.handleCrawlerInitiate(this.props.details.data, false);
        },
      );
    }
  };

  handleDataAutomationRequiredData = event => {
    let tempAutomationData = {};
    if (event.target.name === "GST") {
      tempAutomationData = {
        ...this.state.caseData,
        gstNo: event.target.value,
      };
    } else if (event.target.name === "SOCIALMEDIA") {
      tempAutomationData = {
        ...this.state.caseData,
        SOCIAL_address: event.target.value,
      };
    } else if (event.target.name === "SOCIAL_name") {
      tempAutomationData = {
        ...this.state.caseData,
        SOCIAL_name: event.target.value,
      };
    }
    else {
      tempAutomationData = {
        ...this.state.caseData,
        [event.target.name]: event.target.value,
      };
    }
    this.setState({
      caseData: tempAutomationData,
    });
  };

  handleEntityTypeChange = event => {
    let tempAutomationData = {};

    tempAutomationData = {
      ...this.state.caseData,
      bsaEntityType: event.value,
    };

    this.setState({
      caseData: tempAutomationData,
    });
  };

  handleBankNameChange = event => {
    let tempAutomationData = {};

    tempAutomationData = {
      ...this.state.caseData,
      bsaBankName: event.value,
    };

    this.setState({
      caseData: tempAutomationData,
    });
  };

  handleAccountTypeChange = event => {
    let tempAutomationData = {};

    tempAutomationData = {
      ...this.state.caseData,
      bsaAccountType: event.value,
    };

    this.setState({
      caseData: tempAutomationData,
    });
  };

  handleZigramData = () => {
    if (this.state.caseData.associationEntry) {
      const associationName = this.state.caseData.associationEntry.associationName;
      if (associationName && associationName !== "") {
        let tempAutomationData = [];
        if (this.state.caseData.associationTable && this.state.caseData.associationTable.length > 0) {
          tempAutomationData = [
            ...this.state.caseData.associationTable
          ];
        }
        tempAutomationData.push(this.state.caseData.associationEntry);
        var tempCaseData = {
          ...this.state.caseData,
          associationTable: tempAutomationData,
          associationEntry: {
            ...this.state.caseData.associationEntry,
            associationsType: "",
            associationCountry: "",
            associationPanNumber: "",
            associationName: "",
            associationOrganization: ""
          }
        };
        this.setState({ caseData: tempCaseData });
      }
    }
  }

  handleAssociationExcelUpload = (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    if (file && file.name && file.name.endsWith(".xlsx")) {
      var tempExcelFile = {
        ...this.state.caseData,
        associationExcelFile: file
      };
      this.setState({ caseData: tempExcelFile });
    } else {
      this.setState({
        associationExcelFile: null
      });
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Excel File only !
        </div>
      );
      e.target.value = null;
    }
  }

  handleAssociationTypeChange = (event) => {
    let tempAutomationData = {};
    tempAutomationData = {
      ...this.state.caseData.associationEntry,
      associationsType: event.target.value,
    };
    var tempCaseData = {
      ...this.state.caseData,
      associationEntry: tempAutomationData
    };
    this.setState({ caseData: tempCaseData });
  }

  handleZigramDataOnChange = event => {
    let tempAutomationData = {};
    tempAutomationData = {
      ...this.state.caseData.associationEntry,
      [event.target.name]: event.target.value,
    };
    var tempCaseData = {
      ...this.state.caseData,
      associationEntry: tempAutomationData
    };
    this.setState({ caseData: tempCaseData });
  };

  handleReportType = event => {
    var tempreportType = {
      ...this.state.caseData,
      reportType: event.target.value
    };
    this.setState({ caseData: tempreportType });
  };

  handleCinNum = event => {
    var tempCinNumber = {
      ...this.state.caseData,
      cinNumber: event.target.value
    };
    this.setState({ caseData: tempCinNumber });
  };

  handleRemoveAssociation = (index) => {
    let tempAutomationData = {};
    const updatedAssociations = [...this.state.caseData.associationTable];
    updatedAssociations.splice(index, 1);
    var tempCaseData = {
      ...this.state.caseData,
      associationTable: updatedAssociations
    };
    this.setState({ caseData: tempCaseData });
  }

  handleSubmitZigramData = (zigramData) => {
    this.setState({
      zigramModel: false
    });
    this.props.preloading(true);
    this.props.initiateZigramExcelRequest(zigramData);

  }

  handleBsaFileUpload = (event) => {
    console.log(event)
    console.log(event.target.files)
    if (event.target.files && event.target.files.length <= 12) {
      let bsaFilesRelated = {}
      let validatedPdfFiles = []
      for (let i = 0; i < event.target.files.length; i++) {
        let fileName = event.target.files[i].name;
        let fileExtention = fileName.substr(fileName.length - 4);
        if (fileExtention === ".pdf") {
          validatedPdfFiles[i] = event.target.files[i]
        }
        else {
          toast.error(
            <div>
              <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload PDF files only.
            </div>
          )
          bsaFilesRelated = {
            ...this.state.caseData,
            bsaPdf: [],
            totalBsaPdfsSelected: 0
          }
          this.setState({ caseData: bsaFilesRelated });
          return;
        }
      }
      bsaFilesRelated = {
        ...this.state.caseData,
        bsaPdf: validatedPdfFiles,
        totalBsaPdfsSelected: validatedPdfFiles.length
      }
      this.setState({ caseData: bsaFilesRelated })
    }
    else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload PDF files not more than 12.
        </div>
      )
    }
  }


  handleInitiateReport = () => {
    let validateAutomationDataMessage = validateAutomationData(
      this.state.dataAutomationData,
      this.state.caseData
    );
    if (validateAutomationDataMessage.length < 1) {
      this.props.preloading(true);
      let tempRequestBody = setRequestBodyDataAutomation(this.state.dataAutomationData, this.state.caseData, this.props.companyNameOnAgency, this.state.commonjson, this.state.latestXbrlXmlFile, this.state.previousXbrlXmlFile);
      console.log("final temp Req: ", tempRequestBody.requestBody);
      let requestBody = new FormData();
      requestBody.append('crawlerModel', JSON.stringify(tempRequestBody.requestBody));
      
      // Mark this as an OTP initiation request to prevent modal closure
      this.setState({ 
        isOtpInitiationRequest: true,
        otpInitiateDisabled: true 
      });
      
      this.props.dataAtuomationInitiate(requestBody);
    }
    else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{validateAutomationDataMessage}
        </div>,
      );
    }

  }

  handleInitiateAadhaarOtpRequest = () => {
    let validateAutomationDataMessage = validateKycAutomationData(
      this.state.kycAutomationData,
      this.state.kycCrawlerData,
      false
    );
    if (validateAutomationDataMessage.length < 1) {
      let tempRequestBody = setKycRequestBodyDataAutomation(this.state.kycAutomationData, this.state.kycCrawlerData, this.state.caseData);
      this.props.preloading(true);
      let requestBody = new FormData();
      requestBody.append('kycCrawlerModel', JSON.stringify(tempRequestBody.requestBody));
      this.props.kycDataAtuomationInitiate(requestBody);
    } else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{validateAutomationDataMessage}
        </div>,
      );
    }
  }

  handleKycCrawlerRunAutomation = () => {
    let validateAutomationDataMessage = validateKycAutomationData(
      this.state.kycAutomationData,
      this.state.kycCrawlerData,
      true
    );
    if(this.state.selectedCheckBox === "KYB"){
      let selectedCompanyName=this.state.kycCrawlerData.selectCounterpartyName;
      let selectedRegisterNumber=this.state.kycCrawlerData.selectRegisterNumber;
      let countryCode=this.state.selectedCountry.id;
      let requestBody={
        "countryCode": countryCode,
        "name": selectedCompanyName ? selectedCompanyName : "",
        "registerNumber": selectedRegisterNumber ? selectedRegisterNumber : ""
    }
    if((selectedCompanyName || selectedRegisterNumber) && countryCode) {
      this.handleKycCrawlerModal(false)
      this.props.preloading(true);
      this.props.fetchKybData(requestBody);
      this.setState({showKybTable:true});
      return;
    }
    }
    if (validateAutomationDataMessage.length < 1) {
      let tempRequestBody = setKycRequestBodyDataAutomation(this.state.kycAutomationData, this.state.kycCrawlerData, this.state.caseData);
      this.props.preloading(true);
      let requestBody = new FormData();
      requestBody.append('kycCrawlerModel', JSON.stringify(tempRequestBody.requestBody));
      this.props.kycDataAtuomationInitiate(requestBody);
      this.toggleKycModal();
    } else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{validateAutomationDataMessage}
        </div>,
      );
    }

  }


  handleRunAutomation = () => {
    // Ensure this is not treated as OTP initiation
    this.setState({ isOtpInitiationRequest: false });
    
    let validateAutomationDataMessage = validateAutomationData(
      this.state.dataAutomationData,
      this.state.caseData,
      this.state.epfNumbers
    );
    if (validateAutomationDataMessage.length < 1) {
      this.props.preloading(true);
      let tempRequestBody = setRequestBodyDataAutomation(this.state.dataAutomationData, this.state.caseData, this.props.companyNameOnAgency, this.state.commonjson, this.state.latestXbrlXmlFile, this.state.previousXbrlXmlFile);

      let legalRequestbody = {
        corporateId: this.state.caseData.corporateId,
        panNo: this.state.caseData.panNo,
        counterpartyId: this.state.caseData.counterpartyId,
        caseId: this.state.caseData.caseId,
        crawlerName: 'LEGAL',
        counterpartyName: this.state.caseData.LEGAL_name, /* address: this.state.caseData.LEGAL_address, */
        nameMatchType: this.state.caseData.legalMatchType,
        state: this.state.caseData.state
      }
      
      if (this.state.dataAutomationData.GST || this.state.dataAutomationData.PAN || this.state.dataAutomationData.MCA || this.state.dataAutomationData.DIN || this.state.dataAutomationData.EPF || this.state.dataAutomationData.STOCK_EXCHANGE 
        || this.state.dataAutomationData.RATINGS || this.state.dataAutomationData.INTERNATIONAL || this.state.dataAutomationData.XBRL || this.state.dataAutomationData.NEWS || this.state.dataAutomationData.SOCIALMEDIA 
        || this.state.dataAutomationData.LEI || this.state.dataAutomationData.IEC || this.state.dataAutomationData.UDYAM || this.state.dataAutomationData.UDYOG || this.state.dataAutomationData.NICCODE_SEARCH 
        || this.state.dataAutomationData.GST_ANALYSIS || this.state.dataAutomationData.BANK_STATEMENT_ANALYSIS || this.state.dataAutomationData.RETAIL_BUREAU || this.state.dataAutomationData.ITR_ANALYSIS 
        || this.state.dataAutomationData.EMAIL || this.state.dataAutomationData.LEGAL) {
        let requestBody = new FormData();
        requestBody.append('crawlerModel', JSON.stringify(tempRequestBody.requestBody));
        requestBody.append('latest', this.state.latestXbrlXmlFile);
        requestBody.append('previous', this.state.previousXbrlXmlFile);
        if (this.state.caseData && this.state.caseData.bsaPdf) {
          this.state.caseData.bsaPdf.forEach(pdf => {
            requestBody.append(`bsaPdf`, pdf);
          });
        }
        this.props.dataAtuomationInitiate(requestBody);
      }
      if (this.state.dataAutomationData.AML_PEP) {
        var associationTable = [];
        if (this.state.caseData.associationTable) {
          associationTable = [...this.state.caseData.associationTable];
          var newtable = [];
          if (associationTable) {
            for (let i = 0; i < associationTable.length; i++) {
              const associationCountryStr = associationTable[i].associationCountry;
              let countryArr;
              if (associationCountryStr && associationCountryStr.includes(',')) {
                countryArr = associationCountryStr.split(",");
              } else if (associationCountryStr) {
                countryArr = [associationCountryStr];
              } else {
                countryArr = [];
              }

              const associationOrganizationStr = associationTable[i].associationOrganization;
              let organizationArr;
              if (associationOrganizationStr) {
                organizationArr = [associationOrganizationStr];
              } else {
                organizationArr = [];
              }

              var assoEntry = {
                associationName: associationTable[i].associationName,
                associationCountry: countryArr,
                associationsType: associationTable[i].associationsType,
                associationPanNumber: associationTable[i].associationPanNumber,
                associationOrganization: organizationArr
              }
              newtable.push(assoEntry);
            }
          }
        }

        let zigramRequestData = {
          zigramRequestbody: {
            counterpartyId: this.state.selectedRowData.counterpartyId,
            counterpartyName: this.state.selectedRowData.counterpartyName,
            type: this.state.caseData.reportType,
            cinNumber: this.state.caseData.cinNumber,
            associations: newtable,
            caseId: this.state.caseData.caseId
          },
          associationExcelFile: this.state.caseData.associationExcelFile
        };

        this.props.initiateZigramRequest(zigramRequestData)
      }

      if (this.state.dataAutomationData.MCA_DATA_SYNC) {
            this.props.initiateMasterDataSync({
                counterpartyId: this.state.selectedRowData.counterpartyId,
                caseId: this.state.caseData.caseId
            });
        }
      this.toggleModal();
    } else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{validateAutomationDataMessage}
        </div>,
      );
    }
  };


  handleOnholdWithdrawPopup = (caseStatus) => {
    this.setState(prevState => ({
      onHoldWithdrawModal: !prevState.onHoldWithdrawModal,
      onHoldWithdrawCaseStatus: caseStatus,
      onHoldWithdrawReasonList: this.state.caseData.onHoldWithdrawReasons
    }));
  }

  handleOnHoldWithdrawDropdownValue = (selectedReason) => {
    this.setState({
      onHoldWithdrawReason: selectedReason
    })
  }


  closeOnholdWithdrawModal = () => {
    this.setState(prevState => ({
      onHoldWithdrawModal: !prevState.onHoldWithdrawModal,
      onHoldWithdrawReason: null
    }));
  }

  
  handleOnHoldWithdrawCase = () => {
    if (this.state.onHoldWithdrawReason === null || this.state.onHoldWithdrawReason === "" 
      || this.state.onHoldWithdrawReason === "Not Applicable") {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Reason Can Not Be Empty or Not Applicable
        </div>,
      );
    } else {
      this.props.preloading(true);
      this.closeOnholdWithdrawModal();
      if (this.state.onHoldWithdrawCaseStatus && this.state.onHoldWithdrawCaseStatus !== null){
        this.props.withdrawCase({
          caseStatus: this.state.onHoldWithdrawCaseStatus,
          reportRequestCaseId: this.props.details.data.id,
          reason: this.state.onHoldWithdrawReason,
        });
      }
    }
  }

  changeCaseToPendingToggle = () => {
    this.setState(prevState => ({
      changeCaseToPendingModal: !prevState.changeCaseToPendingModal,
    }));
  }


  markCaseAsPending = () => {
    this.changeCaseToPendingToggle();
    this.props.preloading(true);
    this.props.markCasePending(this.props.details.data.caseId);
  }
  
  uploadXbrlFile = data => {
    this.props.preloading(true);
    this.props.uploadXbrlFile({
      file: data.target.files[0],
      id: this.props.details.data.counterpartyId,
    });
  };
  downloadXbrl = (event, data) => {
    event.preventDefault();
    this.props.preloading(true);
    this.props.downloadXbrlFile(data);
  };
  rerunProcessing = data => {
    this.props.preloading(true);
    this.props.rerunProcessing(data);
  };

  handleAutomation = data => {
    this.props.dataAtuomationInitiate(data);
  };

  moderateLegal = () => {
    this.setState({ moderateLegal: !this.state.moderateLegal })
  }

  moderateAdditionalLegal = () => {
    this.setState({ moderateAdditionalLegal: !this.state.moderateAdditionalLegal })
  }

  moderateNews = () => {
    this.setState({ moderateNews: !this.state.moderateNews })
  }

  allocatePartner = () => {
    this.setState({ allocatePartner: !this.state.allocatePartner })
  }

  submitKybModalTable = () => {
    if(Object.keys(this.state.kybSelectedEntity).length>0){
    this.props.preloading(true);
    this.props.kybRecordSubmit({...this.state.kybSelectedEntity, counterpartyId: this.state.caseData.counterpartyId,caseId: this.state.caseData.caseId});
    this.setState({showKybTable:false})
  }else{
    toast.info(
      <div>
        <i className="fa fa-exclamation-triangle"></i>&nbsp;{"Please select a KYB Data"}
      </div>,
    );
  }
  }

  closeKybModalTable = () => {
    this.setState({
      showKybTable: false
    })
  }

 searchCallback = (selected, type) => {
this.setState({
  selectedCountry: selected
})
        
}

handleCountryAutocomplete=(event)=>{
}
  render() {
    const { details } = this.props;
    const { value } = this.state;
    let inputProps = {
      placeholder: "Search Country",
      value,
      onChange: this.onChange,
      disabled: false,
      className: "form-control"
  };
    let viewPublish;
    let viewDownload;
    let visibleButtons;
    if (hasCompleted(details)) {
      visibleButtons = (
        <ButtonGroup size="sm" className="mb-2">
          {this.props.userDetails.scopes[0] === "ROLE_RUBIXADMIN" && ![constant.WITHDRAWN, constant.ONHOLD].includes(details.data.status) && (
            <Button
              outline
              color="primary"
              title="Reopen Case"
              onClick={this.handleReopenCase}
            >
              <i className="fa fa-undo" aria-hidden="true"></i>&nbsp;Reopen Case
            </Button>
          )}

          {details.data.status !== constant.ONHOLD && (
            <>
              <Button
                outline
                color="primary"
                title="View Report"
                onClick={this.viewPublishedReport}
              >
                <i className="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;View Report
              </Button>

              <Button
                outline
                color="primary"
                title="Download PDF"
                onClick={this.viewDownloadedReport}
              >
                <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Download PDF
              </Button>
            </>
          )}

          {details.data.status === constant.ONHOLD && (
            <>
              <Button
                outline
                color="primary"
                title="Mark Pending"
                onClick={this.changeCaseToPendingToggle}
              >
                <i className="fa fa-play" aria-hidden="true"></i>&nbsp;Mark Pending
              </Button>

              <Button outline color="primary" title="Withdraw Case" onClick={() => this.handleOnholdWithdrawPopup(constant.WITHDRAWN)}>
                <i className="fa fa-unlink" aria-hidden="true"></i> &nbsp;Withdraw Case
              </Button>
            </>
          )}
        </ButtonGroup>
      );
    } else {
      visibleButtons = (
        <ButtonGroup size="sm" className="mb-2">
          {/* <Button outline color="primary" title="Preview Report" onClick={this.handlePreview}>
            <i className="fa fa-eye" aria-hidden="true"></i> &nbsp;Preview &amp; Publish Report
          </Button> */}
          {/* <Button outline color="primary" title="Reorder" onClick={this.handleRearrangeModal}>
            <i className="fa fa-reorder" aria-hidden="true"></i> &nbsp;Reorder
          </Button> */}
          {details && details.hasOwnProperty('data') && (details.data.caseType === constant.INTERNATIONAL) &&
            <Button outline color="primary" title="Allocate Partner" onClick={() => this.allocatePartner()}>
              <i className="fa fa-plus-circle" aria-hidden="true"></i> &nbsp;Allocate Partner
            </Button>}
          {(this.state.cralwerButtonFlag) && <Button
            //disabled={this.state.cralwerButtonFlag}
            outline
            className={getCrawlerStatusType(this.state.kycCrawlerStatus)}
            title="Initiate Crawler "
            onClick={() => this.handleKycCrawlerInitiate(true)}
          >

            <i className={
              this.state.kycCrawlerStatus === 'SUCCESS' ? "fa fa-check-circle crawler-status-icon text-success"
                : this.state.kycCrawlerStatus === 'FAILURE' ? "fa fa-times-circle crawler-status-icon text-danger"
                  : this.state.kycCrawlerStatus === 'PARTIAL_FAILURE' ? "fa fa-exclamation-triangle crawler-status-icon text-warning"
                    : this.state.kycCrawlerStatus === 'INPROGRESS' ? "fa fa-spinner crawler-status-icon text-warning"
                      : "fa fa-play-circle crawler-status-icon text-primary"
            } ></i>{" "}

            &nbsp;Initiate Kyc Crawler
          </Button>}
          {(this.state.cralwerButtonFlag) && <Button
            //disabled={this.state.cralwerButtonFlag}
            outline
            className={getCrawlerStatusType(this.state.crawlerStatus)}
            title="Initiate Crawler "
            onClick={() => this.handleCrawlerInitiate(this.props.details.data, true)}
          >

            <i className={
              this.state.crawlerStatus === 'SUCCESS' ? "fa fa-check-circle crawler-status-icon text-success"
                : this.state.crawlerStatus === 'FAILURE' ? "fa fa-times-circle crawler-status-icon text-danger"
                  : this.state.crawlerStatus === 'PARTIAL_FAILURE' ? "fa fa-exclamation-triangle crawler-status-icon text-warning"
                    : this.state.crawlerStatus === 'INPROGRESS' ? "fa fa-spinner crawler-status-icon text-warning"
                      : "fa fa-play-circle crawler-status-icon text-primary"
            } ></i>{" "}

            &nbsp;Initiate Crawler
          </Button>}
          {this.state.enableModeration &&
            <UncontrolledDropdown caret="true" className="dropdown dropdown-moderation">
              <DropdownToggle color="" className="moderation">
                Moderation&ensp;<i className={"fa fa-caret-down"} aria-hidden="true"></i>{" "}
              </DropdownToggle>
              <DropdownMenu>
                {this.state.legalModeration.isLegalCrawlerSucceed && this.props.legalUnprocessedData && this.props.legalUnprocessedData.legalCases.length > 0 &&
                  <Button
                    disabled={this.state.legalModeration.legalModerationStatus === "INPROGRESS"}
                    className={[getCrawlerStatusType(this.state.legalModeration.legalModerationStatus), "moderation-item"]}
                    outline
                    title="Legal Moderation"
                    onClick={() => this.moderateLegal()}>
                    <i className={this.state.legalModeration.legalModerationStatus === "INPROGRESS" ? "fa fa-spinner" : this.state.legalModeration.legalModerationStatus === "SUCCESS" ? "fa fa-check-circle" : "fa fa-scissors"} aria-hidden="true"></i>{" "}
                    &nbsp;Legal Moderation
                  </Button>
                }
                {this.state.additionalLegalModeration.isAdditionalLegalCrawlerSucceed && this.props.additionalLegalUnprocessedData && this.props.additionalLegalUnprocessedData.legalCases.length > 0 &&
                  <Button
                    disabled={this.state.additionalLegalModeration.legalModerationStatus === "INPROGRESS"}
                    className={[getCrawlerStatusType(this.state.additionalLegalModeration.legalModerationStatus), "moderation-item"]}
                    outline
                    title="Additional Legal Moderation"
                    onClick={() => this.moderateAdditionalLegal()}>
                    <i className={this.state.additionalLegalModeration.legalModerationStatus === "INPROGRESS" ? "fa fa-spinner" : this.state.additionalLegalModeration.legalModerationStatus === "SUCCESS" ? "fa fa-check-circle" : "fa fa-scissors"} aria-hidden="true"></i>{" "}
                    &nbsp;Additional Legal Moderation
                  </Button>
                }
                {this.state.newsModeration.isNewsCrawlerSucceed && this.props.newsUnprocessedData && this.props.newsUnprocessedData.newsDetails.length > 0 &&
                  <Button
                    disabled={this.state.newsModeration.newsModerationStatus === "INPROGRESS"}
                    className={[getCrawlerStatusType(this.state.newsModeration.newsModerationStatus), "moderation-item"]}
                    outline
                    title="News Moderation"
                    onClick={() => this.moderateNews()}>
                    <i className={this.state.newsModeration.newsModerationStatus === "INPROGRESS" ? "fa fa-spinner" : this.state.newsModeration.newsModerationStatus === "SUCCESS" ? "fa fa-check-circle" : "fa fa-scissors"} aria-hidden="true"></i>{" "}
                    &nbsp;News Moderation
                  </Button>
                }
              </DropdownMenu>
            </UncontrolledDropdown>}
          <Button
            outline
            color="primary"
            title="Close Case"
            onClick={this.handlePreview}
          >
            {/*handleCloseCase*/}
            <i className="fa fa-lock" aria-hidden="true"></i> &nbsp;Close Case
          </Button>

          <Button outline color="primary" title="Onhold Case" onClick={() => this.handleOnholdWithdrawPopup(constant.ONHOLD)}>
            <i className="fa fa-pause-circle" aria-hidden="true"></i> &nbsp;On Hold Case
          </Button>

          <Button outline color="primary" title="Withdraw Case" onClick={() => this.handleOnholdWithdrawPopup(constant.WITHDRAWN)}>
            <i className="fa fa-unlink" aria-hidden="true"></i> &nbsp;Withdraw Case
          </Button>
        </ButtonGroup >
      )
    }
    return (
      <Col>
        <div className="d-flex">
          <h4 className="mr-auto p-2">Case Details</h4>
          {visibleButtons}
        </div>
        <AboutView
          metadata={this.state.caseData}
          viewPublishedReport={viewPublish}
          viewDownloadedReport={viewDownload}
          uploadXbrlCallback={this.uploadXbrlFile}
          userDetails={this.props.userDetails}
          xbrlDetails={this.props.xbrlDetails}
          downloadXbrl={this.downloadXbrl}
          rerunProcessing={this.rerunProcessing}
          automationCallback={this.handleAutomation}
        />
        <ViewSections rearrange={this.state.status} />
        {this.state.moderateLegal && <LegalModeration open={this.state.moderateLegal} moderationType={"LEGAL"} name={this.state.legalModeration.name} moderateLegal={this.moderateLegal} corporateId={this.state.legalModeration.corporateId} counterpartyId={this.state.legalModeration.counterpartyId} />}
        {this.state.moderateAdditionalLegal && <LegalModeration open={this.state.moderateAdditionalLegal} moderationType={"ADDITIONAL_LEGAL"} name={this.state.additionalLegalModeration.name} moderateAdditionalLegal={this.moderateAdditionalLegal} corporateId={this.state.additionalLegalModeration.corporateId} counterpartyId={this.state.additionalLegalModeration.counterpartyId} />}
        {this.state.moderateNews && <NewsModeration open={this.state.moderateNews} name={this.state.newsModeration.name} moderateNews={this.moderateNews} corporateId={this.state.newsModeration.corporateId} counterpartyId={this.state.newsModeration.counterpartyId} />}
        {this.state.allocatePartner && <AllocatePartner open={this.state.allocatePartner} allocatePartner={this.allocatePartner} countryCode={this.state.caseData.geoData.sortname} caseId={this.state.caseData.caseId} counterpartyName={this.state.caseData.counterpartyName} additionalFields={this.state.additionalFields} />}
        {(this.state.kycCrawlerModal || this.state.kycBody) && <Modal show={this.state.kycModal} modalClosed={this.handleKycToggle} className="Large-Modal">
          {this.state.kycCrawlerModal ? <KycDataAutomation
            handleCountryAutocomplete={this.handleCountryAutocomplete}
            searchCallback={this.searchCallback}
            selectedCountry={this.state.selectedCountry}
            selectedCounterpartyStatus={this.props.KycCrawlerStatusSuccess}
            kycAutomationData={this.state.kycAutomationData}
            handleKycCheckboxchange={this.handleKycCheckboxchange}
            close={this.handleKycCrawlerModal}
            getKycCrawlerStatus={this.handleGetKycCrawlerStatus}
            counterpartyAddress={this.state.caseData.counterpartyAddress}
            caseData={this.state.caseData}
            kycCrawlerData={this.state.kycCrawlerData}
            handleKycCrawlerData={this.handleKycCrawlerData}
            handleKycCrawlerRunAutomation={this.handleKycCrawlerRunAutomation}
            handleInitiateAadhaarOtpRequest={this.handleInitiateAadhaarOtpRequest}
            caseNo={this.props.match.params.caseNo}
            selectedCheckBox={this.state.selectedCheckBox}
          /> : this.state.kycBody}
        </Modal>}

        {(this.state.crawlerModal || this.state.body) && <Modal show={this.state.modal} modalClosed={this.handleToggle} className="Large-Modal">
          {this.state.crawlerModal ? <DataAutomation
            selectedCounterpartyStatus={this.props.crawlerStatusSuccess}
            selectedRowData={this.state.selectedRowData}
            handleTextChange={this.handleDataAutomationRequiredData}
            handleRunCallback={this.handleRunAutomation}
            handleInitiateReport={this.handleInitiateReport}
            markCrawlerAsfailure={this.markCrawlerAsfail}
            dataAutomationData={this.state.dataAutomationData}
            handleCheckboxchange={this.handleCheckboxchange}
            close={this.handleCrawlerModal}
            getCrawlerStatus={this.handleGetCrawlerStatus}
            handleNewsData={this.handleNewsData}
            handleLegalData={this.handleLegalData}
            downloadAdditionalLegalTemplate={this.downloadAdditionalLegalTemplate}
            downloadAMLPEPTemplate={this.downloadAMLPEPTemplate}
            uploadAdditionalLegalFile={this.uploadAdditionalLegalFile}
            handleRatingsData={this.handleRatingsData}
            handleBseNseData={this.handleBseNseData}
            stockType={this.state.caseData.stockType}
            handleSocialMediaData={this.handleSocialMediaData}
            handleLegalDropdownData={this.handleLegalDropdownData}
            handleLeiData={this.handleLeiData}
            handleRetailBureauData={this.handleRetailBureauData}
            handleIECData={this.handleIECData}
            handleUdyamData={this.handleUdyamData}
            handleUdyogData={this.handleUdyogData}
            handleItrAnalysisRequest={this.handleItrAnalysisRequest}
            handleItrResync={this.handleItrResync}
            itrResyncInProgress={this.props.itrResyncStatus === "PENDING"}
            handleEmailRequest={this.handleData}
            handleNicData={this.handleNicData}
            otpInitiateDisabled={this.state.otpInitiateDisabled}
            loadNICOptions={this.loadNICOptions}
            type={this.state.caseData.searchType}
            name={this.state.caseData.LEGAL_name}
            counterpartyAddress={this.state.caseData.counterpartyAddress}
            ratingsType={this.state.caseData.ratingsSearchType}
            leiSearchType={this.state.caseData.leiSearchType}
            caseData={this.state.caseData}
            retailBureauRequestType={this.state.caseData.retailBureauRequestType}
            nicSelectedValue={this.state.caseData.nicSelectedValue}
            nicOptionsList={this.state.nicOptionsList}
            ratingTab={this.openRatingsCompanySearchTab}
            companyNames={this.props.companyNameOnAgency}
            caseNo={this.props.match.params.caseNo}
            uploadXML={this.uploadXML}
            handleAgencyDropdown={this.handleAgencyDropdown}
            xmlFile={this.state.xmlFile}
            epfData={this.props.epfData}
            uploadLatestXbrlXml={this.uploadLatestXbrlXml}
            uploadPreviousXbrlXml={this.uploadPreviousXbrlXml}
            latestXbrlXmlFile={this.state.latestXbrlXmlFile}
            previousXbrlXmlFile={this.state.previousXbrlXmlFile}
            bsaEntityTypes={this.state.bsaEntityTypes}
            handleEntityTypeChange={this.handleEntityTypeChange}
            bsaBankNames={this.state.bsaBankNames}
            handleBankNameChange={this.handleBankNameChange}
            bsaAccountTypes={this.state.bsaAccountTypes}
            handleAccountTypeChange={this.handleAccountTypeChange}
            handleBsaFileUpload={this.handleBsaFileUpload}
            handleZigramData={this.handleZigramData}
            handleZigramDataOnChange={this.handleZigramDataOnChange}
            handleRemoveAssociation={this.handleRemoveAssociation}
            associationTable={this.state.caseData.associationTable}
            reportType={this.state.caseData.reportType}
            handleReportType={this.handleReportType}
            cinNumber={this.state.caseData.cinNumber}
            handleCinNum={this.handleCinNum}
            handleAssociationTypeChange={this.handleAssociationTypeChange}
            handleAssociationExcelUpload={this.handleAssociationExcelUpload}
            associationExcelFile={this.state.caseData.associationExcelFile}
            associationEntry={this.state.caseData.associationEntry ? this.state.caseData.associationEntry : {}}
            totalBsaPdfsSelected={this.state.caseData.totalBsaPdfsSelected ? this.state.caseData.totalBsaPdfsSelected : 0}
            userDetails={this.props.userDetails}
          /> : this.state.body}
        </Modal>}
        {this.state.zigramModel ? <ZigramModel zigramData={this.state.zigramData} open={this.state.zigramModel} handleSubmitZigramData={(zigramData) => this.handleSubmitZigramData(zigramData)} /> : null}
        {/* <Modal show={this.state.zigramModel} className='legal-modal Large-Modal' >
          <ModalHeader className="justify-content-center">
            Legal Moderation -
          </ModalHeader>
          <ModalBody>
            <ZigramTableView
              tasks={Object.values(this.state.zigramData)}
              handleOnChange={this.handleOnChange} />
          </ModalBody>
          <ModalFooter>

          </ModalFooter>

        </Modal> */}
        <Modal show={this.state.xbrlModal} className='Modal' >
          {this.state.xbrlModalbody}
        </Modal> 
        <Modal show={this.props.fetchedKYBdata && this.state.kybModalBody && this.state.showKybTable} className='legal-modal Large-Modal'>
          <ModalBody>
            {this.state.kybModalBody}
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col>
                  <Button color="info" className="justify-content-center" disabled={Object.keys(this.state.kybSelectedEntity).length>0 ? false : true} onClick={this.submitKybModalTable}>Submit</Button>
              </Col>
              <Col>
                  <Button color="info" className="justify-content-center" onClick={this.closeKybModalTable}>Close</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>

        {/* On Hold - Withdraw Modal */}
          <Modal show={this.state.onHoldWithdrawModal} className={'Modal shadow-none onhold-withdraw-modal'} >
            <ModalHeader className="label-text-center">
              {this.state.onHoldWithdrawCaseStatus === constant.WITHDRAWN ? "WITHDRAW" : this.state.onHoldWithdrawCaseStatus} Case Confirmation</ModalHeader>
            <ModalBody>
                <Row>
            <Label className="label-text-center" style={{padding : "0.61rem 1.428rem"}}>Reason: </Label>
            <Col>
              <Select
                className="px-3 align-items-center"
                value={this.state.onHoldWithdrawReason ? { label: this.state.onHoldWithdrawReason, value: this.state.onHoldWithdrawReason } : null}
                onChange={(selectedOption) => this.handleOnHoldWithdrawDropdownValue(selectedOption ? selectedOption.value : "")}
                options={this.state.onHoldWithdrawReasonList.map(reason => ({ label: reason, value: reason }))}
                isClearable={false}
                menuShouldScrollIntoView={false}
              />
            </Col>
                </Row>
            </ModalBody>
            <ModalFooter style={{ paddingTop: '10%' }}>
                <Button color="secondary" onClick={this.closeOnholdWithdrawModal}>Cancel</Button>
                <Button color="primary" onClick={this.handleOnHoldWithdrawCase}>Confirm</Button>
            </ModalFooter>
          </Modal>

          {/* change case from OnHold to Pending Modal */}
        <Modal show={this.state.changeCaseToPendingModal} className='Modal shadow-none cp-upload-modal' >
          <ModalHeader className="label-text-center">Change Case Status To Pending Confirmation</ModalHeader>
          <ModalBody>
              <Row>
                  <Label className="label-text-center" style={{padding : "0.61rem 1.428rem"}}>Are your sure you want to change case status to PENDING ?</Label>
              </Row>
          </ModalBody>
          <ModalFooter>
              <Button color="secondary" onClick={this.changeCaseToPendingToggle}>Cancel</Button>
              <Button color="primary" onClick={this.markCaseAsPending}>Confirm</Button>
          </ModalFooter>
        </Modal>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  userDetails: state.loginDetails.userDetails,
  details: state.section.caseDetails,
  caseDetailsError: state.section.caseDetailsError,
  sections: state.section.sectionList,
  sectionListError: state.section.sectionListError,
  reorder: state.section.reorder,
  zigramData: state.commonCaseComponentReducer.zigramData,
  zigramExcelData: state.commonCaseComponentReducer.zigramExcelData,


  // response from `closeCase`
  closeCaseSuccess: state.section.closeCaseSuccess,
  closeCaseData: state.section.closeCaseData,

  // response from `publishFinalReport`
  publishedReport: state.section.publishedReport,
  publishReportSuccess: state.section.publishReportSuccess,

  // response from `viewPublishedReport`
  viewCompletedReport: state.section.viewCompletedReport,
  viewCompletedReportPdf: state.section.viewCompletedReportPdf,

  // response from `viewDownloadedReport`
  viewDownloadedReport: state.section.viewDownloadedReport,
  viewDownloadedReportPdf: state.section.viewDownloadedReportPdf,

  // response from `reopenCase`
  reopenCaseData: state.section.reopenCaseData,
  withdrawCaseSuccess: state.section.withdrawCaseSuccess,
  withdrawCaseFailure: state.section.withdrawCaseFailure,

  xbrlDetails: state.section.xbrlDetails,
  xbrlDetailsFailure: state.section.xbrlDetailsFailure,
  downloadXbrl: state.section.downloadXbrlFile,
  downloadXbrlFailure: state.section.downloadXbrlFileFailure,
  uploadXbrl: state.section.uploadXbrlFile,
  uploadXbrlFailure: state.section.uploadXbrlFileFailure,
  rerunProcessingSuccess: state.section.rerunProcessing,
  rerunProcessingFailure: state.section.rerunProcessingFailure,

  automationInitiatedSuccess: state.commonCaseComponentReducer.automationInitiatedSuccess,
  automationInitiatedFailure: state.commonCaseComponentReducer.automationInitiatedFailure,
  crawlerStatusSuccess: state.commonCaseComponentReducer.crawlerStatusSuccess,
  crawlerStatusFailure: state.commonCaseComponentReducer.crawlerStatusFailure,

  kycAutomationInitiatedSuccess: state.commonCaseComponentReducer.kycAutomationInitiatedSuccess,
  kycAutomationInitiatedFailure: state.commonCaseComponentReducer.kycAutomationInitiatedFailure,
  KycCrawlerStatusSuccess: state.commonCaseComponentReducer.KycCrawlerStatusSuccess,
  KycCrawlerStatusFailure: state.commonCaseComponentReducer.KycCrawlerStatusFailure,

  legalCrawler: state.commonCaseComponentReducer.legalCrawler,
  legalUnprocessedData: state.legalModeration.legalUnprocessedData,
  additionalLegalTemplate: state.commonCaseComponentReducer.additionalLegalTemplate,
  amlPepTemplate: state.commonCaseComponentReducer.amlPepTemplate,
  additionalLegalUploadResponse: state.commonCaseComponentReducer.additionalLegalUploadResponse,
  additionalLegalUnprocessedData: state.additionalLegalModeration.additionalLegalUnprocessedData,
  newsCrawler: state.commonCaseComponentReducer.newsCrawler,
  newsUnprocessedData: state.newsModeration.newsUnprocessedData,
  companyNameOnAgency: state.ratingCompanyMap.companyNameOnAgency,
  epfData: state.section.epfData,

  // response from NIC Search
  nicSearchResultList: state.commonCaseComponentReducer.nicSearchResultList,
  fetchedBsaEntityTypes: state.section.bsaEntityTypes,
  fetchedBsaBankNames: state.section.bsaBankNames,
  fetchedBsaAccountTypes: state.section.bsaAccountTypes,

  //response from KYB
  fetchedKYBdata: state.section.kybDetails,
  fetchedKYBdataError: state.section.kybDetailsError,
  kybRecordSubmitSuccess: state.section.kybRecordSubmit,
  kybRecordSubmitError: state.section.kybRecordSubmitError,

  //response from marking case as PENDING
  markCasePendingSuccess: state.section.markCasePendingSuccess,
  markCasePendingFailure: state.section.markCasePendingFailure,
      masterDataSyncData: state.commonCaseComponentReducer.masterDataSyncData,
  masterDataSyncStatus: state.commonCaseComponentReducer.masterDataSyncStatus,
  masterDataSyncError: state.commonCaseComponentReducer.masterDataSyncError,
  itrResyncStatus: state.commonCaseComponentReducer.itrResyncStatus,
  itrResyncMessage: state.commonCaseComponentReducer.itrResyncMessage,
  itrResyncAt: state.commonCaseComponentReducer.itrResyncAt
});

const mapDispatchToProps = dispatch => ({
  getCaseDetails: id => { dispatch(CaseViewActions.getCaseDetails(id)); },
  getAllSections: data => { dispatch(CaseViewActions.getAllSections(data)); },
  previewReport: id => { dispatch(CaseViewActions.previewReport(id)); },
  publishFinalReport: id => { dispatch(CaseViewActions.publishFinalReport(id)); },
  reorderSections: (id, body) => { dispatch(CaseViewActions.reorderSections(id, body)); },
  closeCase: id => { dispatch(CaseViewActions.closeCase(id)); },
  viewPublishedReport: id => { dispatch(CaseViewActions.viewPublishedReport(id)); },
  viewDownloadedReport: (id, name) => { dispatch(CaseViewActions.viewDownloadedReport(id, name)); },
  reopenCase: (caseId, id) => { dispatch(CaseViewActions.reopenCase(caseId, id)); },
  changeReorderStatus: () => { dispatch(CaseViewActions.changeReorderStatus()); },
  preloading: isPreloading => { dispatch(Preloading(isPreloading)); },
  withdrawCase: data => { dispatch(CaseViewActions.withdrawCase(data)); },
  fetchXbrlDetails: data => { dispatch(CaseViewActions.fetchXbrlDetails(data)); },
  downloadXbrlFile: data => { dispatch(CaseViewActions.downloadXbrlFile(data)); },
  uploadXbrlFile: data => { dispatch(CaseViewActions.uploadXbrlFile(data)); },
  rerunProcessing: data => { dispatch(CaseViewActions.rerunProcessing(data)); },
  dataAtuomationInitiate: data => { dispatch(dataAtuomationInitiate(data)); },
  kycDataAtuomationInitiate: data => { (dispatch(kycDataAtuomationInitiate(data))) },
  nicSearchRequest: data => { dispatch(nicSearchRequest(data)); },
  getCrawlerStatus: data => { dispatch(getCrawlerStatus(data)); },
  getKycCrawlerStatus: data => { dispatch(getKycCrawlerStatus(data)); },
  initiateLegalCrawler: data => { dispatch(initiateLegalCrawler(data)) },
  legalSectionTemplateRequest: data => { dispatch(legalSectionTemplateRequest(data)) },
  requestUnporcessedLegalDataForModeration: data => { dispatch(requestUnporcessedLegalDataForModeration(data)) },
  requestUnprocessedAdditionalLegalDataForModeration: data => { dispatch(requestUnprocessedAdditionalLegalDataForModeration(data)) },
  requestUnporcessedNewsDataForModeration: data => { dispatch(requestUnporcessedNewsDataForModeration(data)) },
  responseOfUnprocessedData: data => { dispatch(responseOfUnprocessedData(data)) },
  responseOfUnprocessedNewsData: data => { dispatch(responseOfUnprocessedNewsData(data)) },
  responseOfUnprocessedAdditionalLegalData: data => { dispatch(responseOfUnprocessedAdditionalLegalData(data)) },
  requestMappedCompanyName: id => { dispatch(requestMappedCompanyName(id)) },
  getCaseEPFDetails: id => { dispatch(CaseViewActions.getCaseEPFDetails(id)); },
  getBsaEntityTypes: () => { dispatch(CaseViewActions.getBsaEntityTypes()); },
  getBsaBankNames: () => { dispatch(CaseViewActions.getBsaBankNames()); },
  getBsaAccountTypes: () => { dispatch(CaseViewActions.getBsaAccountTypes()); },
  initiateZigramRequest: data => { dispatch(initiateZigramRequest(data)) },
  initiateZigramExcelRequest: data => { dispatch(initiateZigramExcelRequest(data)) },
  additionalLegalTemplateRequest: () => { dispatch(additionalLegalTemplateRequest()) },
  amlPepTemplateRequest: () => { dispatch(amlPepTemplateRequest()) },
  getCrawlerMarkasfail: (data) => { dispatch(getCrawlerMarkasfail(data)) },
  additionalLegalUploadRequest: data => { dispatch(additionalLegalUploadRequest(data)) },
  fetchKybData:data => { dispatch(CaseViewActions.fetchKybData(data)) },
  kybRecordSubmit:data => { dispatch(CaseViewActions.kybRecordSubmit(data)) },
  markCasePending: data => { dispatch(CaseViewActions.markCasePending(data))},
  initiateMasterDataSync: (counterpartyId) => 
            dispatch(initiateMasterDataSync(counterpartyId)),
  resyncItrAnalysis: (data) => { dispatch(resyncItrAnalysis(data)); },
});

export default withAuth(
  connect(mapStateToProps, mapDispatchToProps)(CaseSectionsComponent),
);
